// extracted by mini-css-extract-plugin
export default {"MarkDownWrapper":"MarkDown_MarkDownWrapper__XnDHH","MarkDown":"MarkDown_MarkDown__BSmyQ"};